import React from 'react';

function Footer() {
    return (
        <footer class="flex flex-row justify-center text-center mx-auto py-4 text-zinc-700 dark:text-zinc-300 relative bg-white dark:bg-black">
            <p>&copy; 2023 (wired-in). All rights reserved.</p>
        </footer>
    );
}

export default Footer;
